module.exports = __webpack_public_path__ + "h5/img/mfe_15.0e9eed93.jpg";